import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export type AuthEvent = 'TokenExpired';

@Injectable({
  providedIn: 'root',
})
export class AuthEventManager {
  private readonly authEventSubject = new Subject<AuthEvent>();
  readonly authEvent$ = this.authEventSubject.asObservable();

  emitEvent(event: AuthEvent): void {
    this.authEventSubject.next(event);
  }
}
